<template>
  <div class="d-flex align-items-center">
    <span class="min-w-9rem me-3 text-center">
      <EditOnClick v-model="value.name" />
    </span>
    <span class="me-1 min-w-3rem text-center">
      <BaseIcon name="posts-tag" />
      <div>
        {{ value.posts_count ?? "-" }}
      </div>
    </span>
    <span class="me-1 min-w-3rem text-center">
      <BaseIcon name="comments-tag" />
      <div>
        {{ value.comments_count ?? "-" }}
      </div>
    </span>
    <span class="min-w-3rem text-center">
      <BaseIcon name="like-tag" />
      <div>
        {{ value.likes_count ?? "-" }}
      </div>
    </span>
  </div>
</template>

<script>
import BaseIcon from "../../icons/BaseIcon";
import EditOnClick from "../../inputs/EditOnClick.vue";
export default {
  name: "IntegrationStatisticsBlock",
  components: { EditOnClick, BaseIcon },
  props: {
    id: Number,
    type: String,
    row: Object,
    modelValue: Object,
  },
  data() {
    return {
      value: this.modelValue,
    };
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.$emit("update:modelValue", this.value);
        this.$emit("change", this.value);
        this.$emit("update", this.value);
      },
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  methods: {},
  emits: ["update:modelValue", "change"],
};
</script>
